import React, { useState } from 'react'
import { useStore } from 'react-redux'
import { Table } from 'rsuite'

const { Column, HeaderCell, Cell, Pagination } = Table

export const TableCell = ({ rowData, dataKey, users = [], ...props }) => {
  return (
    <Cell {...props} className="table-link list-table-cell text-black" id={rowData.id}>
      {(props?.rowKey + 1)}
    </Cell>
  )
}

export const SelectorCell = ({ rowData, dataKey, onChange, onInvite, onView, roleId, ...props }) => {
  return (
    <Cell {...props} className="table-action" fixed>
      <div className="d-flex gap-2">
        {roleId === 3 && (
          <button type="button" className="h4 pt-2 pb-2 rounded mb-0 bg-gray text-white width-100" onClick={() => onInvite(rowData)}>Invite</button>
        )}
        <button type="button" className="h4 pt-2 pb-2 rounded mb-0 btn-green children width-100" onClick={() => onView(rowData)}>View</button>
      </div>
    </Cell>
  )
}

const MyDomainList = ({ selectedDomain, myDomains, onSelectDomain, onShowCreateModal, onShowDetailModal, onShowInviteModal }) => {
  const columns = [
    {
      label: 'No.',
      name: 'No.'
    },
    {
      label: 'Domain Name',
      name: 'domainName'
    },
    {
      label: 'Copmany Name',
      name: 'companyName'
    }
  ]
  const store = useStore().getState()
  const { user, auth } = store
  const { domainUsers } = user
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)

  const currentUserRole = domainUsers.filter(u => u?.user?.id === auth?.user?.id)[0]

  const headerElement = columns.map((h, index) => {
    if (index === 0) {
      return (
        <Column
          resizable
          key={h.name}
          width={50}
        >
          <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
          <TableCell />
        </Column>
      )
    }
    return (
      <Column
        resizable
        key={h.name}
      >
        <HeaderCell className='text-black fw-bold'>{h.label}</HeaderCell>
        <Cell className='text-black' dataKey={h.name} />
      </Column>
    )
  })

  const paginatedData = myDomains?.sort((a, b) => {
  }).slice(limit * (page - 1), limit * page)

  return (
    <div className="mydomain-list">
      <div className="header pb-0">
        <div className="domain-title">
          <h2 className='mb-0 fw-bold text-blue'>Domains</h2>
        </div>
        <div className="tool">
          {currentUserRole?.roleId === 3 &&
            <button type="button" className="h4 mb-0 pb-2 pt-2 rounded width-100 btn-green" onClick={onShowCreateModal}>
              CREATE
            </button>
          }
        </div>
      </div>
      <div className='shadow mt-4 border border-2 rounded'>
        <Table
          virtualized
          autoHeight
          affixHeader={true}
          data={paginatedData}
        >
          {headerElement}
          <Column
            width={250}
            fixed="right"
            key="action"
          >
            <HeaderCell className='text-black fw-bold'>Action</HeaderCell>
            <SelectorCell
              onInvite={onShowInviteModal}
              onView={onShowDetailModal}
              roleId={currentUserRole?.roleId}
            />
          </Column>
        </Table>
        <div className="pagination">
          <Pagination
            prev
            next
            first
            last
            showInfo
            maxButtons={5}
            lengthMenu={[
              {
                label: '5',
                value: 5,
              },
              {
                label: '10',
                value: 10,
              },
              {
                label: '25',
                value: 25,
              },
              {
                label: '50',
                value: 50,
              },
            ]}
            displayLength={limit}
            total={myDomains.length}
            limit={limit}
            activePage={page}
            onChangePage={(event) => { setPage(event) }}
            onChangeLength={(limit) => { setLimit(limit) }}
          />
        </div>
      </div>
      {/* <div className="table">
        <div className="table-header table-row">
          <div className="no table-col">
            No
          </div>
          <div className="table-col">
            Domain Name
          </div>
          <div className="table-col">
            Company Name
          </div>
          <div className="table-col">
            Action
          </div>
        </div>
        <div className="table-body">
          {
            myDomains?.map((domain, index) => (
              <div className={`table-row ${selectedDomain?.id === domain.id ? 'selected' : ''}`} key={domain.id} onClick={() => onSelectDomain(domain)}>
                <div className="no table-col">
                  {index + 1}
                </div>
                <div className="table-col">
                  {domain.domainName}
                </div>
                <div className="table-col">
                  {domain.companyName}
                </div>
                <div className="table-col">
                  <button type="button" className="btn btn-blue" onClick={() => onShowDetailModal(domain)}>
                    View
                  </button>
                  {currentUserRole?.roleId === 3 &&
                    <button type="button" className="btn btn-blue" onClick={() => onShowInviteModal(domain)}>
                      Invite
                    </button>
                  }
                </div>
              </div>
            ))
          }
        </div>
      </div> */}
    </div>
  )
}

export default MyDomainList